module.exports = __webpack_public_path__ + "img/timeline_icon.da0cbb38.png";